import { ReleaseNotes } from '../interfaces';

export const VERSIONS_RELEASE_NOTES: ReleaseNotes[] = [
  {
    version: '3.1.0',
    date: new Date('2026-01-15'),
    features: [
      {
        detail: `Nouvelles notes de versions.`,
      },
    ],
    upgrades: [
      {
        detail: `Refonte visuelle de l'écran des actions.`,
      },
      {
        detail: `Améliorations de l'interface des liens d'un point.`,
      },
    ],
  },
  {
    version: '3.0.0',
    date: new Date('2025-12-16'),
    features: [
      {
        detail: 'Glisser déposer un point dans une séance.',
        new: true,
        videoLink: 'https://www.youtube.com/watch?v=r3BXTbqftJc',
      },
    ],
    bugfixes: [
      {
        detail: `Correction de bugs.`,
      },
    ],
    upgrades: [
      {
        detail: 'Migration vers Angular 17.',
      },
    ],
  },
  {
    version: '2.4.1',
    date: null,
    bugfixes: [
      {
        detail: `Compteur des points qui affichait 0 (en rédaction, à corriger,…).`,
      },
      {
        detail: `Bouton verrouillé via action dans le point.`,
      },
      {
        detail: `Ajouter en fichier via le glisser déposer.`,
      },
      {
        detail: `Service s’affichait empty à la création/modification d’un point.`,
      },
      {
        detail: `Affichage liste des points dans le désordre suite à l’ordre de passage.`,
      },
      {
        detail: `Destinataires d’un point pour info ne s’affichaient plus.`,
      },
      {
        detail: `Vue liste des points, affichage des destinataires ne s’actualisait pas en passant d’un point à l’autre.`,
      },
      {
        detail: `Date de la séance vide à la modification d’un point envoyé en correction.`,
      },
    ],
  },
  {
    version: '2.4.0',
    date: null,
    upgrades: [
      {
        detail: `Ajout de l'information des points lu et non lu.`,
      },
      {
        detail: `Génération de fichiers - Points non inclus dans une séance.`,
      },
      {
        detail: `Point - Amélioration de l'historique.`,
      },
      {
        detail: `Recherche avancée de points - Ajout des utilisateurs inactifs.`,
      },
    ],
    bugfixes: [
      {
        detail: `Duplication d'un point - Suppression des étapes.`,
      },
      {
        detail: `Duplication d'un point - Problème lors d'une deuxième duplication.`,
      },
      {
        detail: `Duplication d'un point - Reprise des fichiers.`,
      },
      {
        detail: `Recherche avancée de points - Agent traitant.`,
      },
      {
        detail: `Point - Sélection du destinataire principal.`,
      },
      {
        detail: `Point - Date d'échéance des actions.`,
      },
      {
        detail: `Point - Sélection du type de point en fonction du type parametré dans la séance.`,
      },
    ],
  },
  {
    version: '2.3.0',
    date: null,
    upgrades: [
      {
        detail: `Réorganisation des points dans la séance.`,
      },
      {
        detail: `Création d'un point.`,
      },
      {
        detail: `Modification dans l'import des fichiers iCourrier.`,
      },
      {
        detail: `Modification dans le changement de statut en masse pour les séances et pour les points.`,
      },
      {
        detail: `Recherche avancée de points - Ajout du classement.`,
      },
      {
        detail: `Fusion des documents - ajout de la fusion des extraits conformes.`,
      },
      {
        detail: `Extrait conforme - Ajout de la recherche des signataires.`,
      },
      {
        detail: `Extrait conforme - Ajout des annexes en fonction du paramétrage.`,
      },
      {
        detail: `iScan - automatisation de l'encodage pour Mandataire et Citoyen.`,
      },
    ],
    bugfixes: [
      {
        detail: `Recherche avancée dans les séances sur les statuts.`,
      },
      {
        detail: `Problème dans le nombre de votants lorsqu'une personne est encodée absente.`,
      },
      {
        detail: `Affichage de la date dans l'historique.`,
      },
      {
        detail: `Perte des accès iDélibé Mandataire à la modification d'une fiche contact.`,
      },
      {
        detail: `Compteur des points.`,
      },
      {
        detail: `Affichage des évènements dans la séance.`,
      },
    ],
  },

  {
    version: '2.2.0',
    date: null,
    upgrades: [
      {
        detail: `Ajout d'un sous-menu dans les "Pour la sélection.`,
      },
      {
        detail: `Recherche avancée des points: Refonte visuelle.`,
      },
      {
        detail: `Recherche avancée des points: Ajout du créateur.`,
      },
      {
        detail: `Point: Agent traitant ne peut être qu'un utilisateur.`,
      },
      {
        detail: `Point: Création du classement directement depuis iDelibé.`,
      },
      {
        detail: `Point: Ajout de la recherche dans le classement.`,
      },
      {
        detail: `Point: Ajout du "passage service" dans la création et la mise à jour du point.`,
      },
      {
        detail: `Documents: Ne plus rendre exportable l'ancienne version du document lors de la génération d'un nouveau.`,
      },
      {
        detail: `Services: Ajout de la recherche dans les listings de sélection.`,
      },
      {
        detail: `IScan: Optimisation de la création des documents.`,
      },
      {
        detail: `Actions: Optimisations de la page de listing des actions.`,
      },
      {
        detail: `Actions: Ajout du statut dans le traitement de l'action.`,
      },
    ],

    bugfixes: [
      {
        detail: `Suppression d'un évènement.`,
      },
      {
        detail: `Point reporté: Garder le rédacteur initial du point.`,
      },
      {
        detail: `Génération de documents: des puces changent de format à la génération.`,
      },
      {
        detail: `Traitement d'une action.`,
      },
      {
        detail: `Sélection du service via iCourrier.`,
      },
    ],
  },
  {
    version: '1.9.0',
    date: null,
    upgrades: [
      {
        detail: `Export mandataire : Ordre des fichiers.`,
      },
      {
        detail: `Bandeau d'avertissement concernant l'ordre réel.`,
      },
      {
        detail: `Éditeur de texte: Correcteur orthographique (Français, Anglais, Néerlandais, Allemand).`,
      },
      {
        detail: `Éditeur de texte: Ajout de la police "Open Sans".`,
      },
      {
        detail: `Report d'un point.`,
      },
    ],

    bugfixes: [
      {
        detail: `Suppression du lien entre une séance et un lieu inconnu.`,
      },
      {
        detail: `Message d'erreur lors de la suppression de participant.`,
      },
      {
        detail: `Génération d'extrait conforme.`,
      },
      {
        detail: `Duplication d'un point depuis la séance.`,
      },
      {
        detail: `Pop-up lors de "pas de vote".`,
      },
      {
        detail: `Fichier importé d'un courrier ne se coche pas "visible mandataire" ou "visible citoyen" automatiquement.`,
      },
    ],
  },
  {
    version: '1.7.4',
    date: null,
    upgrades: [
      {
        detail: `Changement d'emplacement du statut de la séance.`,
      },
      {
        detail: `Refonte du menu action en haut à droite.`,
      },
    ],

    bugfixes: [
      {
        detail: `Correction de la remontée de la donnée « titre du point » et augmentation de la limite de caractères, « type de décision qui par défaut sera décide», provenant de 3P.`,
      },
      {
        detail: `Si un point 3P a été archivé dans idélibé, vous pourrez le mettre à jour en le réimportant de 3P pour ensuite, le traiter et l'importer dans votre séance.`,
      },
      {
        detail: `Reporter un point via le menu séance.`,
      },
    ],
  },
  {
    version: '1.7.3',
    date: null,
    upgrades: [
      {
        detail: `La mise à jour du titre du point lorsque celui-ci est modifié.`,
      },
      {
        detail: `Problème de multiplication d’un point dans une séance qui entraine une mauvaise numérotation.`,
      },
    ],

    bugfixes: [
      {
        detail: `Scan: possibilité de supprimer une page et de pouvoir identifier manuellement le fichier grâce à l’ID du point ou de la séance, s’il y a un problème de lecture de QR Code.`,
      },
      {
        detail: `Possibilité d’ajouter plusieurs documents en une fois dans un point.`,
      },
      {
        detail: `Suppression d’une séance par le gestionnaire si le droit lui est octroyé.`,
      },
      {
        detail: `Ajout d’un focus dans le menu point, qui met le curseur directement dans la zone de recherche.`,
      },
      {
        detail: `Onglet du navigateur contient plus de détails pour identifier le point ou la séance.`,
      },
    ],
  },
  {
    version: '1.7.1',
    date: null,
    features: [
      {
        detail: `Extrait conforme avec un droit qui permet de modifier les signatures et de les générer en lot et/ou individuellement par utilisateur (droit à activer).`,
      },
    ],
    upgrades: [
      {
        detail: `Une icone a été ajoutée dans la vue séance qui permet de visualiser directement si un point est en cours de modification par un utilisateur.`,
      },
    ],
    bugfixes: [
      { detail: `Modification multiple des statuts d'un point.` },
      { detail: `Envoi multiple de point en correction.` },
      { detail: `Ajouter des fichiers dans une séance.` },
      { detail: `Action visible dans l'onglet destinataire des points non valide pour séance.` },
      { detail: `Permettre de descendre plus bas sur l'écran d'un point pour les petits écran.` },
    ],
  },
  {
    version: '1.7.2',
    date: null,

    bugfixes: [
      { detail: `Créer un point via 3P.` },
      { detail: `Affichage des liens.` },
      { detail: `Affichage liste séance.` },
      { detail: `Création d’un courrier sortant.` },
      { detail: `Recherche avancée dans le menu séance.` },
      { detail: `Tri colonne qui ne restait pas en mémoire dans le menu séance.` },
      { detail: `Filtre dans le menu point.` },
    ],
  },
  {
    version: '1.7.1',
    date: null,
    features: [
      {
        detail: `Extrait conforme avec un droit qui permet de modifier les signatures et de les générer en lot et/ou individuellement par utilisateur (droit à activer).`,
      },
    ],
    upgrades: [
      {
        detail: `Une icone a été ajoutée dans la vue séance qui permet de visualiser directement si un point est en cours de modification par un utilisateur.`,
      },
    ],
    bugfixes: [
      { detail: `Modification multiple des statuts d'un point.` },
      { detail: `Envoi multiple de point en correction.` },
      { detail: `Ajouter des fichiers dans une séance.` },
      { detail: `Action visible dans l'onglet destinataire des points non valide pour séance.` },
      { detail: `Permettre de descendre plus bas sur l'écran d'un point pour les petits écran.` },
    ],
  },
  {
    version: '1.7.0',
    date: null,
    features: [
      {
        detail: `Mise en forme des ruptures dans l'OJ et le PV.`,
      },
      {
        detail: `Champ de fusion id du point.`,
      },
      {
        detail: `Lien icourrier-idélibé.`,
      },
    ],

    bugfixes: [
      {
        detail: `Recherche avancée.`,
      },
      {
        detail: `Chargement historique.`,
      },
      {
        detail: `Affichage des séances après avoir fait un tri sur la date de séance.`,
      },
    ],
  },
  {
    version: '1.6.0',
    date: null,
    features: [
      {
        detail: `Verrouillage de la séance entraine le verrouillage automatique des points.`,
      },
    ],
    upgrades: [
      {
        detail: `Tableau menu point : affichage par défaut des colonnes, redimensionner colonnes.`,
      },
      {
        detail: `Duplication de point : vider le statut, le type de séance, la date de séance et le type de décision + le bouton dupliquer est disponible pour chaque point dans la vue tableau des points de la séance.`,
      },
      {
        detail: `Gestionnaire : bloquer l'ajout d'un point dans une séance clôturée.`,
      },
      {
        detail: `Extrait de délibération : les agents ne peuvent générer d'aperçu des extraits. Ils peuvent y avoir accès dans l'onglet fichier du fichier dès que le gestionnaire l'aura générer.`,
      },
      {
        detail: `Création d'un point : la fenêtre du titre d'un point s'adapte à la longueur de l'objet du point.`,
      },
      {
        detail: `Recherche rapide dans le menu point : permet de rechercher sur des chiffres.`,
      },
    ],
    bugfixes: [
      {
        detail: `Vote : ordre de préséance respecté.`,
      },
      {
        detail: `Limiter les actions des agents dans un point.`,
      },
    ],
  },
  {
    version: '1.5.1',
    date: null,
    features: [
      {
        detail: `Ajout de la recherche dans le contenu du point.`,
      },
      {
        detail: `Possibilité d'ajouter des ET et des OU dans la recherche du point.`,
      },
    ],
    upgrades: [
      {
        detail: `Affichage du n° ID du point + recherche sur l'ID.`,
      },
      {
        detail: `Verrouiller la séance, verrouille les points aussi.`,
      },
    ],
    bugfixes: [
      {
        detail: `Bouton pour importer des fichiers d'une fiche courrier dans le point fonctionne sans devoir cliquer sur modifier.`,
      },
      {
        detail: `Bouton 3P fonctionne correctement et affiche bien les points.`,
      },
      {
        detail: `Recherche avancée - les agents ne voient dans la liste des services que les services dont ils sont membres (je vous rassure avant ils voyaient tous les services mais n'avaient de toute façon pas de résultat sauf si un paramètre particulier était activé).`,
      },
      {
        detail: `Catégorie de point affiche que les points dans la catégorie sélectionnée (sera effectif demain matin car on l'a oublié dans la version de cette fin de journée).`,
      },
      {
        detail: `iScan - les fichiers ajoutés sont considérés comme des fichiers associés et plus des annexes.`,
      },
      {
        detail: `iScan - les fichiers ajoutés dans le point sont bien complet au téléchargement et à l'aperçu.`,
      },
      {
        detail: `Bouton supprimer des fichier est revenu.`,
      },
      {
        detail: `Modification d'un point - toutes les données peuvent être modifiés.`,
      },
    ],
  },
  {
    version: '1.5.0',
    date: null,
    features: [
      {
        detail: `Ajout de la recherche dans le contenu du point.`,
      },
      {
        detail: `Possibilité d'ajouter des ET et des OU dans la recherche du point.`,
      },
    ],
    upgrades: [
      {
        detail: `Affichage des Agents traitant par ordre alphabétique dans la création d'un point.`,
      },
      {
        detail: `Empêcher la modification du statut du point lorsque le point est verrouillé en écriture.`,
      },
      {
        detail: `Suppression de la pagination du listing des points d'une séance.`,
      },
    ],
    bugfixes: [
      {
        detail: `iScan, mauvais liens entre le fichier et le point ou la séance.`,
      },
      {
        detail: `Redirection et tris dans le listing des séances.`,
      },
      {
        detail: `Affichage de mauvais fichiers dans les points sans fichier.`,
      },
    ],
  },
  {
    version: '1.4.0',
    date: null,
    features: [
      {
        detail: `Lecteur de code QR.`,
      },
      {
        detail: `Lien avec 3P.`,
      },
    ],
    upgrades: [
      {
        detail: `Génération par lot : il est possible d'écraser des documents déjà générés`,
      },
      {
        detail: `Éditeur : couleur noir par défaut + afficher les espaces par défaut`,
      },
      {
        detail: `Affichage tableau séance : garde en mémoire l'ordre et l'affichage des colonnes dans l'onglet des points dans la séance et des points prévus à la séance.`,
      },
      {
        detail: `Gestion de service : pouvoir ajouter un/plusieurs utilisateurs dans un/plusieurs services.`,
      },
      {
        detail: `Changement du visuel pour le choix des votes'.`,
      },
    ],
    bugfixes: [
      {
        detail: `Afficher le nom de l'utilisateur qui a verrouillé le point en écriture.`,
      },
      {
        detail: `Enlever le bandeau de verrouillage dès que le point est déverrouillé.`,
      },
      {
        detail: `Caractères spéciaux ne poseront plus problème pour l'export vers mandataire.`,
      },
      {
        detail: `Ajouter un point dans la bibliothèque via le bouton action dans le point.`,
      },
      {
        detail: `Le texte ne s'affichait plus dans la motivation… via la modification du point.`,
      },
      {
        detail: `Empêcher de créer plusieurs fois les mêmes séances.`,
      },
      {
        detail: `Traiter l'action dans le menu action.`,
      },
      {
        detail: `Filtre dans les tableaux.`,
      },
    ],
  },
  {
    version: '1.3.0',
    date: null,
    features: [],
    upgrades: [],
    bugfixes: [],
  },
  {
    version: '1.2.0',
    date: null,
    features: [
      {
        detail: `Accès concurrent : lorsqu'une personne modifie un point, celui-ci est bloqué en édition pour les autres utilisateurs.`,
      },
    ],
    upgrades: [
      {
        detail: `Amélioration visuelle de la vue du menu séance, de la vue tableau et de la vue liste dans la séance.`,
      },
    ],
    bugfixes: [
      {
        detail: `Blocage à l'enregistrement d'une modification d'un modèle de point.`,
      },
      {
        detail: `Blocage à l'enregistrement d'une modification d'un point.`,
      },
      {
        detail: `Duplication du contenu d'un point.`,
      },
    ],
  },
] as const;
